import { artworkNavQuery } from '@/queries/ArtworkNavQuery';
import gql from 'graphql-tag';
import { pageQuery } from '@/queries/PageQuery';

export const collectionOnlineQuery = gql`
  query getCollection($id: ID!, $type: PageIdType) {
    ${artworkNavQuery}
    ${pageQuery}
  }
`;
